import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { verifyUsers } from 'services/userService';

const AuthGuard = ({ children }: { children: JSX.Element }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isVerifying, setIsVerifying] = useState(true);

  useEffect(() => {
    const checkAuthAndRedirect = async () => {
      try {
        // Check if token exists in localStorage
        const token = localStorage.getItem('access_token');
        if (!token) {
          // No token found, redirect to login unless already on login page
          if (
            !location.pathname.includes('/pages/authentication/simple/sign-in')
          ) {
            navigate('/pages/authentication/simple/sign-in');
          }
          setIsVerifying(false);
          return;
        }

        // Token exists, verify with backend
        const response = await verifyUsers();
        const isAuthenticated = response.status === 'authenticated';
        const isLoginPage = location.pathname.includes(
          '/pages/authentication/simple/sign-in'
        );

        if (isAuthenticated && isLoginPage) {
          navigate('/dashboard'); // Redirect authenticated users away from login page
        } else if (!isAuthenticated && !isLoginPage) {
          // If token exists but is invalid, clear it and redirect to login
          localStorage.removeItem('access_token');
          localStorage.removeItem('csrf_token');
          navigate('/pages/authentication/simple/sign-in');
        }
      } catch (error) {
        console.error('Authentication check failed:', error);
        // Clear any invalid tokens
        localStorage.removeItem('access_token');
        localStorage.removeItem('csrf_token');

        if (
          !location.pathname.includes('/pages/authentication/simple/sign-in')
        ) {
          navigate('/pages/authentication/simple/sign-in');
        }
      } finally {
        setIsVerifying(false);
      }
    };

    checkAuthAndRedirect();
  }, [navigate, location.pathname]);

  // Optional: Show loading state while verifying
  if (isVerifying) {
    return <div>Verifying authentication...</div>;
  }

  return children;
};

export default AuthGuard;
